<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button id="help-btn-real-time-overview" type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>
  <div class="top-bar">
    <span class="page-header">{{ 'realtime:RealtimeQueues' | i18next }}</span>
       <!-- <div class="center" *ngIf="showClock">
        <app-clock></app-clock>
      </div> -->
      <div class="right">
      <app-filter-input id="filter-input-real-time-overview" [(model)]="filter" (modelChange)="applyFilterFromProperty()"
      [placeholder]="'realtime:shared_lang_tableFilterLabel' | i18next" [width]="'350px'"></app-filter-input>
      </div>
  </div>
  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 full-width-table">

      <!-- Queue Name -->
      <ng-container matColumnDef="queueName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:queueName' | i18next }}
        </th>
        <td mat-cell *matCellDef="let q">
          <a *ngIf="q.alarmFlag > 0" class="alarm-status" (click)="onAlarmClick(q)" [attr.data-qid]="q.queueID" aria-label="alarm">
            <i class="fas fa-exclamation-circle"></i>
          </a>
         <span >{{q.queueName | htmlDecode }}</span>
          <!-- alarm icon (clickable like old app) -->
          <!-- <a
            *ngIf="q.alarmFlag > 0"
            href="javascript:void(0)"
            class="alarm-status"
            (click)="onAlarmClick(q)"
            [attr.data-qid]="q.queueID"
            aria-label="alarm"
          >
            <img
              class="alarm-icon"
              src="/admin/Content/Img/Main/timeEntry_warning.png"
              alt="alarm"
            />
          </a> -->
        </td>
      </ng-container>

      <!-- Total in Queue (links to queue details if showActionLinks) -->
      <ng-container matColumnDef="queueSize">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:totalSize' | i18next }}
        </th>
        <td mat-cell *matCellDef="let q" class="text-right">
          <ng-container *ngIf="showActionLinks; else qs_plain">
            <a
              [routerLink]="['/real-time/overview/queue', q.queueID]"
              class="queue-details-link"
              [attr.data-qid]="q.queueID"
            >{{ q.queueSize ?? '—' }}</a>
          </ng-container>
          <ng-template #qs_plain>{{ q.queueSize ?? '—' }}</ng-template>
        </td>
      </ng-container>

      <!-- Callback -->
      <ng-container matColumnDef="callback">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:callback' | i18next }}
        </th>
        <td mat-cell *matCellDef="let q" class="text-right">{{ q.callback ?? 0 }}</td>
      </ng-container>

      <!-- Preferred -->
      <ng-container matColumnDef="preferred">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:preferred' | i18next }}
        </th>
        <td mat-cell *matCellDef="let q" class="text-right">{{ q.preferred ?? 0 }}</td>
      </ng-container>

      <!-- Scheduled (links to scheduled page if showActionLinks) -->
      <ng-container matColumnDef="ciqScheduled">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:scheduled' | i18next }}
        </th>
        <td mat-cell *matCellDef="let q" class="text-right">
          <ng-container *ngIf="showActionLinks; else sched_plain">
            <a [routerLink]="['/real-time/overview/sched', q.queueID]">
              {{ q.ciqScheduled ?? 0 }}
            </a>
          </ng-container>
          <ng-template #sched_plain>{{ q.ciqScheduled ?? 0 }}</ng-template>
        </td>
      </ng-container>

      <!-- SLA Score -->
      <ng-container matColumnDef="sla">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:SLA' | i18next }}
        </th>
        <td mat-cell *matCellDef="let q" class="text-right">{{q.formattedSLA | htmlDecode }}</td>
      </ng-container>

      <!-- Max Wait Time -->
      <ng-container matColumnDef="waitTimeMax">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:maxHoldTime' | i18next }}
        </th>
        <td mat-cell *matCellDef="let q" class="text-right">{{ q.formattedWaitTimeMax }}</td>
      </ng-container>

      <!-- Agents Logged on (clickable if showActionLinks) -->
      <ng-container matColumnDef="agentsLoggedIn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:agentLogon' | i18next }}
        </th>
        <td mat-cell *matCellDef="let q" class="text-right">
          <ng-container *ngIf="showActionLinks; else agents_plain">
            <a
              class="agents-details-link"
              [routerLink]="['/real-time/overview/agent', q.queueID]"
              [attr.data-qid]="q.queueID"
            >
              {{ q.agentsLoggedIn ?? 0 }}<ng-container *ngIf="q.unblockableLoggedIn !== null">/{{ q.unblockableLoggedIn }}</ng-container>
            </a>
          </ng-container>
          <ng-template #agents_plain>
            {{ q.agentsLoggedIn ?? 0 }}<ng-container *ngIf="q.unblockableLoggedIn !== null">/{{ q.unblockableLoggedIn }}</ng-container>
          </ng-template>
        </td>
      </ng-container>

      <!-- Agents In Pause -->
      <ng-container matColumnDef="agentsInPause">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:agentInPause' | i18next }}
        </th>
        <td mat-cell *matCellDef="let q" class="text-right">{{ q.agentsInPause ?? 0 }}</td>
      </ng-container>

      <!-- Agent (link to agent details if showActionLinks) -->
      <!-- <ng-container matColumnDef="agent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:agent' | i18next }}
        </th>
        <td mat-cell *matCellDef="let q">
          <ng-container *ngIf="showActionLinks; else agent_plain">
            <a
              class="agents-details-link"
              [routerLink]="['/real-time/overview/agent', q.queueID]"
              [attr.data-qid]="q.queueID"
            >{{ 'realtime:agent' | i18next }}</a>
          </ng-container>
          <ng-template #agent_plain>{{ 'realtime:agent' | i18next }}</ng-template>
        </td>
      </ng-container> -->
<!-- (Optional) Info icon column like old "Display Queues" info -->
<ng-container matColumnDef="info">
  <th mat-header-cell *matHeaderCellDef><!-- intentionally empty --></th>
  <td mat-cell *matCellDef="let q" class="info-cell">
    <app-basic-button id="queue-info-btn-{{q.queueID}}" type="secondary" isIcon="true" size="small" (click)="onDisplayQueuesInfo(q)"
      [attr.data-qid]="q.queueID" *ngIf="showActionLinks"
      [matTooltip]="'realtime:system_queues_tooltip_info_icon' | i18next">
      <i class="fal fa-info-circle fa-2xs"></i>
    </app-basic-button>
  </td>
</ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ 'alarm-row': row.alarmFlag > 0 }"
      ></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>
    </table>
  </div>
</div>

